import { Box, Button, Drawer, Stack, TextField } from '@mui/material';
import React, { useState } from 'react';


function Dealer({ open, rowDealer, SaveDealerChanges, onClose }: { open: boolean; rowDealer: any, SaveDealerChanges: any, onClose: any }) {
    const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
    const [currentRow, SetCurrentRow] = useState([] as any);

    React.useEffect(() => {
        SetOpenDrawer(open);
    }, [open]);

    function OnSaveClick() {
        SaveDealerChanges(currentRow);
    }

    React.useEffect(() => {
        if(open==true){
            const cloneRow={...rowDealer};
            
            SetCurrentRow(cloneRow);
        }
        SetOpenDrawer(open);
    }, [open]);

    function SetValue(key: string, value: any) {
        currentRow[key] = value;
    }

    return (
        <Box>
            <Drawer
                PaperProps={{ style: { width: 'auto' } }}
                anchor="right"
                open={openDrawer}
                onClose={() => onClose(0)}
                variant={'temporary'}
            >
                <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
                    <Box style={{ width: "100%" }}>
                        <Box>
                            <TextField
                                disabled
                                required
                                id="outlined-required"
                                label="Serial Number"
                                value={rowDealer.serialNumber}
                                style={{ width: "300px" }}
                            />
                        </Box>
                        <Box style={{ marginTop: "10px" }}>
                            <TextField
                                disabled
                                required
                                id="outlined-required"
                                label="Name"
                                value={rowDealer.name}
                                style={{ width: "300px" }}
                            />
                        </Box>
                        <Box style={{ marginTop: "10px" }}>
                            <TextField
                                required
                                id="outlined-required"
                                label="Company Password"
                                defaultValue={rowDealer.companyPw}
                                onChange={(e: any) => { SetValue('companyPw', e.target.value) }}
                                style={{ width: "300px" }}
                            />
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center" style={{ padding: "10px", border: "0px solid red" }}>
                        <Button color="primary" variant="contained" size="small" onClick={OnSaveClick}>Save Changes</Button>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    );
}
export default Dealer